import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeepHomeComponent } from './components/keep-home/keep-home.component';
import { KeepRepairComponent } from './components/keep-repair/keep-repair.component';
import { KeepWarrantyComponent } from './components/keep-warranty/keep-warranty.component';
import { KeepRoutineComponent } from './components/keep-routine/keep-routine.component';
import { KeepControlComponent } from './components/keep-control/keep-control.component';

import { KeepRoutingModule } from './keep.routing';
import { KeepComponent } from './keep.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from 'src/app/common/modules/shared/shared.module';
import { KeepAppointmentComponent } from './components/keep-appointment/keep-appointment.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';

import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatChipsModule} from '@angular/material/chips';
import { KeepSearchComponent } from './components/keep-search/keep-search.component';
import { DealerSearchComponent } from '../account/elements/dealer-search/dealer-search.component';

@NgModule({
  declarations: [
    KeepComponent,
    KeepHomeComponent,
    KeepSearchComponent,
    KeepRepairComponent,
    KeepWarrantyComponent,
    KeepRoutineComponent,
    KeepControlComponent,
    KeepAppointmentComponent
  ],
  imports: [
    CommonModule,
    KeepRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    
    MatIconModule,
    MatButtonModule,

    MatIconModule,
    MatButtonModule,
    MatStepperModule,
    MatSlideToggleModule,
    MatCheckboxModule,

    MatDatepickerModule,
    MatNativeDateModule,

    MatCardModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,

    MatAutocompleteModule,
    MatChipsModule,
    
    DealerSearchComponent
  ]
})
export class KeepModule { }
